import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchStockAdjustmentInfo = (adjustmentNumber, parameters = {}) => {
  const params = getUrlParameters(parameters);
  return apiActionCreator({
    'endpoint': `/parts/stock-adjustment/${adjustmentNumber}${params}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_STOCK_ADJUSTMENT_INFO,
      ActionTypes.FETCHED_STOCK_ADJUSTMENT_INFO,
      [
        ActionTypes.FETCHED_STOCK_ADJUSTMENT_INFO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const createNewAdjustment = (data) => apiActionCreator({
  'endpoint': '/parts/stock-adjustment/manuals',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_NEW_ADJUSTMENT,
    [
      ActionTypes.CREATED_NEW_ADJUSTMENT,
      MessageActions.addMessageBoxInfo('Ajuste ingresado satisfactoriamente'),
    ],
    [
      ActionTypes.CREATED_NEW_ADJUSTMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});

export const processStockAdjustment = (data) => apiActionCreator({
  'endpoint': '/parts/stock-adjustment/process',
  'authenticated': true,
  'types': [
    ActionTypes.PROCESSING_STOCK_ADJUSTMENT,
    [
      ActionTypes.PROCESSED_STOCK_ADJUSTMENT,
      MessageActions.addMessageBoxInfo('Ajuste ingresado satisfactoriamente'),
    ],
    [
      ActionTypes.PROCESSED_STOCK_ADJUSTMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  data,
});

export const addAdjustmentItem = (AdjustmentNumber, index, itemData) => apiActionCreator({
  'endpoint': `/parts/stock-adjustment/manuals/${AdjustmentNumber}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_ADJUSTMENT_ITEM,
    {
      'type': ActionTypes.ADDED_ADJUSTMENT_ITEM,
      'payload': index,
    },
    [
      ActionTypes.ADDED_ADJUSTMENT_ITEM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  'data': itemData,
});


export const removeAdjustmentItem = (AdjustmentNumber, index, itemData) => apiActionCreator({
  'endpoint': `/parts/stock-adjustment/manuals/${AdjustmentNumber}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.REMOVING_ADJUSTMENT_ITEM,
    {
      'type': ActionTypes.REMOVED_ADJUSTMENT_ITEM,
      'payload': index,
    },
    [
      ActionTypes.REMOVED_ADJUSTMENT_ITEM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'DELETE',
  'data': itemData,
});

export const updateStockAdjustmentState = (adjustmentNumber, jdeType, state) => apiActionCreator({
  'endpoint': `/parts/stock-adjustment/${adjustmentNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_STOCK_ADJUSTMENT_STATE,
    [
      ActionTypes.UPDATED_STOCK_ADJUSTMENT_STATE,
      MessageActions.addMessageBoxInfo(`La solicitud ha sido ${state} satisfactoriamente`),
    ],
    [
      ActionTypes.UPDATED_STOCK_ADJUSTMENT_STATE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'PUT',
  'data': {jdeType, state},
});

export const clearAdjustmentInfo = () => ({
  'type': ActionTypes.CLEAR_ADJUSTMENT_INFO,
});
